import { render, staticRenderFns } from "./SubjectEditionPage.vue?vue&type=template&id=5a3d6c39&scoped=true&"
import script from "./SubjectEditionPage.vue?vue&type=script&lang=ts&"
export * from "./SubjectEditionPage.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectEditionPage.vue?vue&type=style&index=0&id=5a3d6c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d6c39",
  null
  
)

export default component.exports